import React from 'react';

import Password from '@Components/login/password';

const PasswordPage = props => (
  <Password {...props} />
);

export default PasswordPage;